export default "dist/images/components-columns-width-control-3-4-uneven.c7484ed.png";